import {createAsyncThunk} from "@reduxjs/toolkit";
import {HealthStatusEnum} from "../../common/enums";
import $api, {API} from "../index";
import axios, {AxiosError} from "axios";

export const getHealthCheck = createAsyncThunk(
    'getHealthCheck',
    async(_, {rejectWithValue}):Promise<HealthStatusEnum>=>{
        try {
            const response = await $api.get(`${API.healthCheck}`);

            return response.data.status;
        } catch (e: any | AxiosError) {
            throw rejectWithValue(e.message);
        }
    }
);

